
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("kXVEY", function(module, exports) {
// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:
const $f4360b64645f7a72$var$links = document.querySelectorAll(".entry-content .kt-img-link, .entry-content a");
$f4360b64645f7a72$var$links.forEach((link)=>{
    const image = link.querySelector(':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img, :scope[href$=".webp"] > img, :scope[href$=".avif"] > img');
    if (!image) return;
    !link.hasAttribute("data-fancybox") && link.setAttribute("data-fancybox", "");
    const alignsClasses = [
        "aligncenter",
        "alignright",
        "alignleft"
    ];
    alignsClasses.forEach((align)=>{
        if (!image.classList.contains(align)) return;
        image.classList.remove(align);
        link.classList.add(align);
    });
});

});


//# sourceMappingURL=entry-content-fancybox-image.f9d93495.js.map
